module.exports = __webpack_public_path__ + "static/media/id-flag.cb29ec0b.png";